


























































import {Vue, Component,Prop} from 'vue-property-decorator';
import * as $ from 'jquery';
import store from '@/store';
import * as api from '@/store/api'



@Component({
})
export default class ChangePassword extends Vue{
    repeatPassword='';
    oldPassword='';
    newPassword='';
    showErrorMessage= false;
    showSuccessfulMessage=false;
    showRepeatPasswordError=false;
    // this.$router.push({ name: 'ChangePassword' })

    clearMessages(){
        this.showRepeatPasswordError=false;
        this.showErrorMessage=false;
        this.showSuccessfulMessage=false;
    }
    async changePassword(){
        const userId =  store.state.userId;
        if(this.newPassword==this.repeatPassword){
            const result=await api.changePassword(userId,this.oldPassword,this.newPassword);
            if(result.isSuccessful){
                this.showSuccessfulMessage=true;
            }else{
                this.showErrorMessage=true;
            }
        }else{
            this.showRepeatPasswordError=true;
        }
       
        
    }

    closeChangePassword(){
        this.$emit('close-password')
    }
}
